import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Tab, Tabs } from '../../components/Tabs/Tabs';
import MainTab from './MainTab';
import { corporateActions } from '../../redux/actions/corporateActions';
import DetailTab from './DetailTab';

const CorporatePage = () => {
  const dispatch = useDispatch();
  const { activeTabKey, tabs } = useSelector(state => state.corporate);

  return (
    <div>
      <Tabs
        activeKey={activeTabKey}
        onClick={key => dispatch(corporateActions.changeTab(key))}
      >
        <Tab title="Perusahaan">
          <MainTab />
        </Tab>
        {tabs.map((row, key) =>
          <Tab
            key={row.key}
            title={row.title}
            isLoading={row.loading}
            onClose={() => dispatch(corporateActions.closeTab(row.key))}
            onClick={() => dispatch(corporateActions.changeTab(row.key))}
            active={activeTabKey === row.key}
          >
            <DetailTab index={key} />
          </Tab>
        )}
      </Tabs>
    </div>
  )
}

export default CorporatePage
